'use strict';

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importDefault(require('react'));

var Icon_1 = __importDefault(require('../Icon'));

var Image = function Image(props) {
  return react_1.default.createElement(
    Icon_1.default,
    __assign({}, props),
    react_1.default.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19 5.5H5C4.17157 5.5 3.5 6.17157 3.5 7V12.3099L7.00173 9.19726C7.27718 8.95241 7.6897 8.94397 7.97493 9.17734L13.0201 13.3052L14.55 12.1578C14.8281 11.9492 15.2131 11.9591 15.4801 12.1816L20.5 16.3649V7C20.5 6.17157 19.8284 5.5 19 5.5ZM20.1185 17.9995L14.9755 13.7137L13.45 14.8578C13.1739 15.0649 12.7922 15.0568 12.5251 14.8383L7.52016 10.7434L3.5 14.3168V17C3.5 17.8284 4.17157 18.5 5 18.5H19C19.4445 18.5 19.8438 18.3067 20.1185 17.9995ZM5 4C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4H5ZM14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5Z',
    })
  );
};

Image.displayName = 'Image';
exports.default = Image;
